import { get } from './requests'

export const getToolboxServices = apiKey =>
  get(['toolbox', 'services'], { apiKey, transformPayload: true })
